<script>
    import NavbarMenu from '../navbar/navbar_menu.svelte';
    import Navbar from '../navbar/navbar.svelte';
    export let check = true;
    export let data;
    export let lineHeight = '4.299vw';
    export let lineHeightMbl = ' 5.299vw ';
    export let marginTop = '0vw';
    export let TopMbl = '123vw';
    export let MargintopMbl = '79.58vw';
    export let widthDescription = '37.516vw';
    export let colors = 'black';
    export let hrTop = '0.2vw';
    export let headingTop = '-4vw';
    export let letterSpace = '0vw';
    export let headingLeft = '1.937vw';
    export let boxTop = '38vw';
    export const textWidth = '60.847vw';
    export let wordSpace = '0vw';
    export let textWidthMbl = '92.5vw';
    export let subheadingMbl = '78.333vw';
    export let discTop = '37.5zvw';
    export let hrWidth = '62.929vw';
    export let detailWidth = '60.847vw';
    export let detailmblWidth = '82.944vw';
    export let detailTop = '11.243vw';

    $: console.log('colors', colors);
    // <!-- Google Tag Manager -->
    (function(w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({'gtm.start': new Date().getTime(), 'event': 'gtm.js'});
        const f = d.getElementsByTagName(s)[0];
        const j = d.createElement(s);
        const dl = l != 'dataLayer' ? '&l=' + l : '';
        j.async = true;
        j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
        f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', 'GTM-N8TD4HQ');
    // <!-- End Google Tag Manager -->
</script>

<section>
    <div>
        <div>
            <div
                class="desktop back-img"
                style="background-image: url('{data.backgroundImage}')"
            >
                <Navbar colorSent={colors} />
            </div>
        </div>
        <div
            class="mobi back-img"
            style="background-image: url('{data.backgroundImageMobi}')"
        >
            <NavbarMenu
                backgroundColor="white"
                stroke="#3C74C0"
                Opacity="0.8"
            />
        </div>
        <div
            class="desktop heading"
            style="position: absolute;top: {headingTop};
                left: {headingLeft};"
        >
            <p
                class="head-text"
                style="line-height:{lineHeight}; margin-top:{marginTop};"
            >
                {@html data.programName}
            </p>
            <hr class="hr" style="margin-top:{hrTop}; width:{hrWidth};" />
            <p
                class="head-text2"
                style="width:{widthDescription};top:{discTop};letter-spacing:{letterSpace}; word-spacing:{wordSpace};"
            >
                {@html data.programdescription}
            </p>
        </div>
        <div class="mobi heading_mbl" style="top:{TopMbl}">
            <p
                class="head-text_mbl"
                style="line-height:{lineHeightMbl};width:{textWidthMbl}"
            >
                {@html data.programName}
            </p>
            <hr class="hr_mbl" />
            <p class="head-text2_mbl" style="width:{subheadingMbl};">
                {@html data.programdescription_mbl}
            </p>
        </div>
        {#if check == true}
            <div class="desktop box" style="top:{boxTop}">
                <div class="program_box ">
                    <p class="program-heading">
                        Upcoming Sessions<span
                            style="font-size:1.190vw; font-weight:300; margin-left:0.5vw;"
                            >{data.week}</span
                        >
                    </p>
                    <div class="program-center">
                        <div
                            style="display: flex; height: fit-content;
                            padding:2vw 0; 
                            width: 30vw;
                            align-items: center;
                            margin-top: auto;
                            margin-bottom: auto;"
                        >
                            {#if data.points2[0].sesion !== ''}
                                <div class="vl-program">
                                    {#each data.points as point}
                                        <p class="program-spring">
                                            {@html point.sesion}
                                        </p>
                                    {/each}
                                </div>
                                <div class="vl-program">
                                    {#each data.points2 as point}
                                        <p class="program-spring">
                                            {point.sesion}
                                        </p>
                                    {/each}
                                </div>
                            {:else}
                                <div
                                    class="vl-program"
                                    style="margin-left: 4.960vw"
                                >
                                    {#each data.points as point}
                                        <p class="program-spring">
                                            {@html point.sesion}
                                        </p>
                                    {/each}
                                </div>
                            {/if}
                        </div>

                        <div
                            style="display: flex;
                        justify-content: center;
                        gap: 0.661vw;"
                        >
                            <div>
                                <button
                                    class="apply_btn"
                                    on:click={() =>
                                        (location.href = '/applyProgram')}
                                >
                                    APPLY NOW
                                </button>
                            </div>
                            <div>
                                <a
                                    href="tel:+16504279813"
                                    style="text-decoration:none;color:black;"
                                >
                                    <button class="call_btn">
                                        <span
                                            class="material-icons"
                                            style="    font-size: 1.5vw;
                                          "
                                        >
                                            call
                                        </span>CALL US
                                    </button>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="box mobi">
                <div class="program_box ">
                    <p style="margin: 0; padding:0;" class="program-heading">
                        Upcoming Sessions
                    </p>
                    <div class="program-center">
                        <div style="display: flex;justify-content:center;">
                            <div>
                                <div class="mobivl-program" />
                                {#each data.points as point}
                                    <p
                                        style="margin: 0; padding:0;"
                                        class="program-spring"
                                    >
                                        {@html point.sesion}
                                    </p>
                                {/each}
                            </div>
                            <div>
                                {#if data.points2[0].sesion !== ''}
                                    <div style="margin-left: 10vw;">
                                        <div class="mobivl-program" />
                                        {#each data.points2 as point}
                                            <p
                                                style="margin: 0; padding:0;"
                                                class="program-spring"
                                            >
                                                {point.sesion}
                                            </p>
                                        {/each}
                                    </div>
                                {/if}
                            </div>
                        </div>
                    </div>
                    <div class="btn-classmobi">
                        <button
                            class="apply-btn"
                            on:click={() => (location.href = '/applyProgram')}
                            >APPLY NOW</button
                        >
                        <a href="tel:+16504279813">
                            <button class="call-btn">
                                <div
                                    style="display: flex;justify-content: center;
                                margin-top: 1.5vw;"
                                >
                                    <div>
                                        <span
                                            class="material-icons"
                                            style="font-size: 5.927vw;
                                        padding-right: 2vw;"
                                        >
                                            call
                                        </span>
                                    </div>

                                    <div style="    margin-top: 0.5vw;">
                                        <p>Call Us</p>
                                    </div>
                                </div>
                            </button>
                        </a>
                    </div>
                </div>
            </div>
        {/if}
    </div>

    <div class="desktop" style="margin-top: {detailTop};">
        <div style="display:flex;align-items:baseline;">
            <div style="position:relative;left:11.839vw;height:20vw;">
                <div class="img-wrraper">
                    <img src={data.img} alt="" width="100%" />
                </div>
            </div>
            <div
                style="margin-left: 3.5vw;
            width: {detailWidth};
            justify-content: center;
            margin-top: auto;
            margin-bottom: auto;"
            >
                <h1 style="font-size: 2.316vw;">
                    <span
                        ><div
                            style="    width: 12.037vw;
                            margin-right: 0.25vw;
                            margin-bottom: 0.8vw;
                            display: inline-block;
                            border-radius: 1.5vw;
                            border-bottom: 0.331vw solid rgb(247, 224, 95);
                            transform: scale(1);"
                        /></span
                    >
                    {@html data.success_description}
                </h1>
            </div>
        </div>
    </div>
    <div class="mobi">
        <div style="margin-top:{MargintopMbl}">
            <div style="position:relative;">
                <div class="img-wrraper">
                    <img src={data.img_mbl} alt="" width="100%" />
                </div>
                <div
                    style="width: {detailmblWidth};margin:auto;margin-top:-18.2vw;"
                >
                    <h1 style="font-size: 4.907vw;line-height: 6.944vw;">
                        <span
                            ><div
                                style="   width: 22.196vw;
                                margin-right: 0.5vw;
                                margin-bottom: 0.8vw;
                                display: inline-block;
                                border-radius: 1.5vw;
                                border-bottom: 1.389vw solid rgb(247, 224, 95);"
                            /></span
                        >
                        {data.success_description}
                    </h1>
                </div>
            </div>
        </div>
    </div>
</section>

<style>
    section {
        font-family: "inter";
    }
    .img-wrraper {
        width: 26.389vw;
        height: 29.914vw;
        border-radius: 0.993vw;
        overflow: hidden;
    }
    .head-text {
        width: 66.918vw;
        font-size: 3.5vw;
        font-weight: 600;
        position: absolute;
        color: white;
        top: 26.521vw;
        left: 8.003vw;
        letter-spacing: 0.1vw;
        text-transform: uppercase;
    }
    .hr {
        color: white;
        opacity: 1;
        width: 33.929vw;
        position: absolute;
        top: 38.21vw;
        left: 8.003vw;
        border: 0.198vw solid;
    }
    .head-text2 {
        width: 39.516vw;
        font-size: 1.7vw;
        font-weight: 600;
        position: absolute;
        color: white;
        left: 8.003vw;
        line-height: 2.513vw;
        padding-top: 2.315vw;
    }
    .program-heading {
        font-weight: bold;
        font-size: 1.323vw;
        margin-top: 2.579vw;
        margin-left: 2vw;
    }
    .program-spring {
        font-weight: normal;
        font-size: 1.123vw;
        margin-left: 1.481vw;
        margin-bottom: 0.455vw;
    }
    .vl-program {
        border-left: 0.397vw solid #f7e05f;
        margin-left: 2.579vw;
    }
    .apply_btn {
        background: #3c74c0;
        border-radius: 1.984vw;
        color: white;
        border: none;
        width: 12.5vw;
        height: 3.638vw;
        font-size: 0.926vw;
    }
    .apply_btn:hover {
        background-color: #f7e05f;
        border: 0.198vw solid #f7e05f;
        color: #3c74c0;
        font-weight: 500;
    }
    .call_btn {
        background: white;
        border-radius: 1.984vw;
        color: rgba(0, 32, 75, 1);
        border: 0.198vw solid black;
        width: 12.5vw;
        height: 3.638vw;
        font-size: 0.926vw;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .call_btn:hover {
        background-color: #f7e05f;
        border: 0.198vw solid #f7e05f;
        color: #3c74c0;
    }
    .material-icons {
        margin-top: 0.1vw;
        padding-right: 0.991vw;
    }
    .back-img {
        height: 45vw;
        background-repeat: no-repeat;
        background-size: cover;
        position: relative;
    }
    .hr {
        color: white;
        opacity: 1;
        margin: 1.2vw 0;
        border: 0.104vw solid;
    }
    .head-text2 {
        font-size: 1.7vw;
        font-weight: 600;
        line-height: 2.515vw;
        color: white;
        word-spacing: 0.1vw;
    }
    .box {
        width: 30.754vw;
        background: white;
        box-shadow: 0vw 0.265vw 1.985vw rgba(0, 0, 0, 0.2);
        border-radius: 0.662vw;
        padding: 2vw 0;
        left: 60.598vw;
        position: absolute;
    }
    .program-heading {
        font-weight: bold;
        font-size: 1.323vw;
        margin-top: -0.5vw;
        margin-left: 2vw;
        margin-bottom: 0vw;
    }
    .program-spring {
        font-weight: normal;
        font-size: 1.123vw;
        margin-left: 1.481vw;
    }
    .mobi {
        display: none;
    }
    @media screen and (max-width: 1024px) {
        .desktop {
            display: none;
        }
        .img-wrraper {
            width: 75.833vw;
            height: 47.222vw;
            overflow: hidden;
            margin-left: 5.278vw;
        }
        .back-img {
            background-repeat: no-repeat;
            background-size: cover;
            height: 176.667vw;
        }
        .back-img::after {
            content: "";
            position: absolute;
            height: 100%;
            width: 100%;
            background: linear-gradient(
                248.88deg,
                rgba(0, 0, 0, 0) -0.05%,
                rgba(0, 0, 0, 0.4) 71.28%
            );
        }
        .box {
            width: 74.444vw;
            padding: 1vw 1vw 6.542vw;
            background: #ffffff;
            box-shadow: 0vw 0.265vw 1.985vw rgba(0, 0, 0, 0.2);
            border-radius: 2.778vw;
            position: absolute;
            left: 13vw;
            top: 166.551vw;
        }
        .program-heading {
            font-weight: 600;
            font-size: 4.444vw;
            text-align: center;
            text-transform: uppercase;
            padding-top: 4.841vw !important;
        }
        .program-spring {
            text-align: center;
            font-size: 3.333vw;
            color: #00204b;
            padding-bottom: 3.505vw !important;
        }
        .program-center {
            margin-top: 2.183vw;
        }
        .mobivl-program {
            border-bottom: 1.265vw solid rgba(247, 224, 95, 1);
            width: 15.278vw;
            border-radius: 0.52vw;
            margin: 3.505vw auto 5.841vw;
        }
        .btn-classmobi {
            display: block;
            margin-left: 5.5vw;
        }
        .apply-btn {
            background: #3c74c0;
            border-radius: 8.333vw;
            color: white;
            font-size: 3.334vw;
            border: none;
            height: 9.346vw;
            width: 61.666vw;
            margin-bottom: 3.271vw;
            text-transform: uppercase;
            margin-top: 2.336vw;
        }
        .call-btn {
            background: white;
            border-radius: 8.333vw;
            color: black;
            font-size: 3.334vw;
            border: 0.199vw solid black;
            height: 9.346vw;
            width: 61.666vw;
            text-transform: uppercase;
            align-items: center;
            justify-content: center;
        }
        .heading_mbl {
            position: absolute;
            left: 50%;
            transform: translate(-50%);
        }
        .head-text_mbl {
            line-height: 10vw;
            font-size: 9.722vw;
            color: white;
            text-align: center;
            font-weight: 600;
            text-transform: uppercase;
        }
        .hr_mbl {
            color: white;
            opacity: 1;
            width: 77.111vw;
            margin: 4.673vw auto;
            border: 0.5vw solid;
        }
        .head-text2_mbl {
            font-size: 4.444vw;
            font-weight: 600;
            line-height: 5.556vw;
            color: white;
            margin: 3vw auto 0vw;
            text-align: center;
            word-spacing: 0.3vw;
            letter-spacing: 0.1vw;
        }
        .mobi {
            display: block;
        }
    }
</style>
